import { render, staticRenderFns } from "./HelpModal.vue?vue&type=template&id=ed2b6ef4&"
import script from "./HelpModal.vue?vue&type=script&lang=js&"
export * from "./HelpModal.vue?vue&type=script&lang=js&"
import style0 from "./HelpModal.vue?vue&type=style&index=0&id=ed2b6ef4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports